import { createApp } from 'vue';
import App from './App.vue'; // Import the root component
import "./assets/styles/global.css"; // Import global styles
import router from './router/router.js'; // Import the router

const app = createApp(App);

app.use(router); // Register the router
app.mount('#app'); // Mount the Vue application